// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__303aL","info":"Note_info__3oxIj","note":"Note_note__91WV2","actions":"Note_actions__1LAIi"};